import React, { useState } from "react";

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <header className="bg-white shadow-sm sticky top-0 z-50">
            <nav className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                {/* Logo Section */}
                <div className="flex items-center space-x-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-8 w-8 text-primary-light"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 14l6-6m-3-3v12M3 10h18M5 14h14M8 18l-2 2h10l-2-2m-4-8v-2a2 2 0 012-2h2a2 2 0 012 2v2m-6 4a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                    </svg>
                    <span className="font-bold text-2xl text-primary-dark">Desi Hauler</span>
                </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex items-center space-x-6">
                    {[
                        { name: "Features", link: "#features" },
                        { name: "Services", link: "#services" },
                        { name: "Why Choose Us", link: "#why-choose-us" },
                        { name: "Our Fleet", link: "#our-fleet" },
                        { name: "About Us", link: "#about" },
                        { name: "Team", link: "#team" },
                        { name: "How It Works", link: "#how-it-works" },
                        { name: "Testimonials", link: "#testimonials" },
                    ].map((item, index) => (
                        <a
                            key={index}
                            href={item.link}
                            className="text-gray-600 hover:text-primary-light transition duration-200 font-medium"
                        >
                            {item.name}
                        </a>
                    ))}

                    <a
                        href="#contact"
                        className="px-6 py-2 rounded-full text-white bg-accent hover:bg-orange-600 transition duration-200 font-semibold"
                    >
                        Get Started
                    </a>
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden text-gray-600 hover:text-primary-light focus:outline-none"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d={
                                isMobileMenuOpen
                                    ? "M6 18L18 6M6 6l12 12" // X icon
                                    : "M4 6h16M4 12h16m-7 6h7" // Menu icon
                            }
                        />
                    </svg>
                </button>
            </nav>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white shadow-lg py-2">
                    {[
                        { name: "Features", link: "#features" },
                        { name: "Services", link: "#services" },
                        { name: "Why Choose Us", link: "#why-choose-us" },
                        { name: "Our Fleet", link: "#our-fleet" },
                        { name: "About Us", link: "#about" },
                        { name: "Team", link: "#team" },
                        { name: "How It Works", link: "#how-it-works" },
                        { name: "Testimonials", link: "#testimonials" },
                    ].map((item, index) => (
                        <a
                            key={index}
                            href={item.link}
                            className="block px-4 py-2 text-gray-600 hover:bg-gray-100"
                        >
                            {item.name}
                        </a>
                    ))}
                    <a
                        href="#contact"
                        className="block px-4 py-2 text-primary-light font-semibold"
                    >
                        Get Started
                    </a>
                </div>
            )}
        </header>
    );
};

export default Header;